// src/components/navigation/shared/DashboardHeader.tsx
import React from 'react';
import { Menu, Bell, User, LogOut, Building2 } from 'lucide-react';
import ShopSelectorbar from './ShopSelectorbar';
import { Shop } from '@cabukaka/types';

interface DashboardHeaderProps {
  onToggleSidebar: () => void;
  isSidebarCollapsed: boolean;
  username: string;
  email: string;
  logoUrl?: string;
  availableShops?: Shop[];
  activeShop: Shop | null;
  onShopChange?: (shop: Shop) => void;
  isAdmin?: boolean; // Nouvelle prop pour savoir si c'est un admin,
  onLogout: ()=>void;
  onGotoProfile: ()=>void
}

const DashboardHeader: React.FC<DashboardHeaderProps> = ({
  onToggleSidebar,
  username,
  email,
  logoUrl,
  availableShops = [],
  activeShop,
  onShopChange,
  isAdmin = false,
  onLogout,
  onGotoProfile
}) => {
  
  return (
    <header className="bg-white border-b border-gray-200 sticky top-0 z-30 shadow-sm">
      <div className="px-6 py-3 flex items-center justify-between">
        {/* Logo + Bouton menu */}
        <div className="flex items-center gap-4">
          <button
            onClick={onToggleSidebar}
            className="p-2 rounded-lg hover:bg-gray-100 transition-colors"
            aria-label="Menu"
          >
            <Menu size={22} />
          </button>

          {logoUrl ? (
            <img src={logoUrl} alt="Logo" className="h-8 w-auto" />
          ) : (
            <span className="text-xl font-bold bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent">
              Cabukaka
            </span>
          )}
        </div>

        {/* Zone centrale : affichage de l'shop active */}
        <div className="flex-1 flex justify-center">
          {isAdmin ? (
            // Admin : affiche le sélecteur pour pouvoir changer
            <ShopSelectorbar
              availableShops={availableShops}
              activeShop={activeShop}
              onChange={onShopChange!}
            />
          ) : (
            // Employé ou compte shop : affiche juste le nom
            activeShop && (
              <div className="flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl border border-blue-100 shadow-sm">
                {activeShop.logo ? (
                  <img
                    src={activeShop.logo}
                    alt={activeShop.name }
                    className="w-6 h-6 rounded-full object-cover"
                  />
                ) : (
                  <div className="p-1 bg-blue-100 rounded-lg">
                    <Building2 size={16} className="text-blue-600" />
                  </div>
                )}
                <span className="text-sm font-semibold text-gray-700">
                  {activeShop.name}
                </span>
              </div>
            )
          )}
        </div>

        {/* Actions utilisateur */}
        <div className="flex items-center gap-2">
          <button className="p-2 rounded-lg hover:bg-gray-100 transition-colors relative">
            <Bell size={20} />
            <span className="absolute top-1.5 right-1.5 w-2 h-2 bg-red-500 rounded-full"></span>
          </button>

          <div className="flex items-center gap-3 pl-2 border-l border-gray-200">
            <div className="text-right hidden sm:block">
              <p className="text-sm font-semibold text-gray-800">{username}</p>
              <p className="text-xs text-gray-500">{email}</p>
            </div>
            <button onClick={onGotoProfile} className="p-2 rounded-lg hover:bg-gray-100 transition-colors">
              <User size={20} className="text-gray-600" />
            </button>
            <button onClick={onLogout} className="p-2 rounded-lg hover:bg-gray-100 transition-colors">
              <LogOut size={20} className="text-gray-600" />
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default DashboardHeader;